module.exports = __webpack_public_path__ + "static/media/countdown-kv.1f3a699e.png";